import React from "react";
import ButtonIconH from "./ButtonIconH";
import "../css/SummarySectionBox.css";

export default function SummarySectionBox({
  name,
  active,
  numElements,
  onOpen,
  row,
}) {
  if (row) {
    const hasCount = numElements >= 0;
    const filled = numElements > 0 || active;
    return (
      <div className={`ssb-row ${filled ? "ssb-row-filled" : ""}`}>
        <div className="ssb-row-info">
          <span className="ssb-row-title">{name}</span>
          {hasCount ? (
            <span className="ssb-row-badge">{numElements}</span>
          ) : (
            filled && <span className="ssb-row-dot"></span>
          )}
        </div>
        <ButtonIconH text="Abrir" small onClick={onOpen}></ButtonIconH>
      </div>
    );
  }

  return (
    <div
      className={`ssb-container ${numElements > 0 || active ? "ssb-fill" : ""}`}
    >
      <span className="section-content-title">{`${name} ${
        numElements >= 0 ? `(${numElements})` : ""
      }`}</span>
      <ButtonIconH text="Abrir" small onClick={onOpen}></ButtonIconH>
    </div>
  );
}
